import React from "react";
 
const Help_Popup = props => {
  return (
<div id="popup1" class="overlay_cus">
	<div class="popup">
		<h3></h3>
		<a class="close hand" onClick={props.handleClose}>&times;</a>
		<div class="content text-justify mt-5">
		Neiman Marcus does not collect sales or use taxes in all states. Your purchase may be subject to use tax unless it is specifically exempt from taxation. Your purchase is not exempt merely because it is made over the Internet, by catalog or by other remote means.Your state may require you to report all purchases that were not taxed and to pay the tax on those purchases on a sales,use or income tax return.Details on how to report and pay these taxes may be found at the applicable state's website. 
		</div>
		<div class="text-left mt-2">
		<button type="button" class="btn close_btn size_12 font_fam mt-4" onClick={props.handleClose}>CLOSE </button>
		</div>
	</div>
</div>
  );
};
 
export default Help_Popup;